<template>
  <div>
    <div v-if="activity.detail" class="w-100">
      <div class="whitespace-preline">{{ activity.detail }}</div>
    </div>
    <div v-else-if="activity.media[0] === undefined" class="w-100">
      Activity widget doesn't understand this log item!
    </div>

    <div v-if="activity.media[0] !== undefined" class="w-100">
      <template
        v-if="
          activity.media[0].mime_type === 'image/jpeg' ||
          activity.media[0].mime_type === 'image/jpg' ||
          activity.media[0].mime_type === 'image/gif' ||
          activity.media[0].mime_type === 'image/png'
        "
      >
        <img
          v-img="{
            src: activity.media[0].url,
            sourceButton: true,
            group: 'activities',
          }"
          :src="activity.media[0].thumbnails['300']"
          alt="Thumbnail"
          class="activity-thumbnail"
          width="100"
        />
      </template>
      <template v-else-if="activity.media[0].mime_type === 'application/pdf'">
        View attached
        <pdf-object :href="activity.media[0].url" />
      </template>
      <template v-else>
        View attached <a :href="activity.media[0].url" target="_blank">file</a>
      </template>
    </div>
  </div>
</template>

<script type="text/babel">
import Vue from "vue";
import VueImg from "v-img";
import BaseComponent from "./BaseComponent.vue";

Vue.use(VueImg);

export default {
  extends: BaseComponent,
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.activity-thumbnail {
  min-width: 100px;
  min-height: 50px;
}
</style>
